import React,  { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Navbar, Alert } from 'react-bootstrap';
import { InfoCircle, BoxArrowInUpRight } from 'react-bootstrap-icons';
import List from '../components/list';
import Picker from '../components/mosqueePicker';
import { Link } from "react-router-dom";

const data = [
  {
    value: "gmca",
    label: "Grande mosquée de Clermont-Auvergne (15 Rue du Dr Nivet, 63100 Clermont-Ferrand)",
    adress: "15 Rue du Dr Nivet, 63100 Clermont-Ferrand",
    link: "https://www.google.fr/maps/place/Grande+Mosqu%C3%A9e+de+Clermont-Ferrand/@45.7870653,3.0918538,17z/data=!3m1!4b1!4m5!3m4!1s0x47f719586b96cacf:0x85db8cbc09a78c20!8m2!3d45.7870653!4d3.0940425?hl=fr"
  }
];

function Home() {
  const [mosquee, setMosquee] = useState("gmca");

  return (
    <div className="w-100 h-100">
      <Navbar bg="dark" variant="dark" className="d-flex justify-content-between flex-column flex-sm-row">
        <div className="d-flex flex-column text-white ml-sm-4 ml-1 mb-sm-0 mb-3 text-center text-sm-left">
          <h3>Grande Mosquée de Clermont-Auvergne</h3>
          {/*<h3>Conseil Régional du Culte Musulman d'Auvergne</h3>
          <span>Calendrier des prières dans les Mosquées d'Auvergne</span>*/}
        </div>
        <Link to="/login" className="mr-2 mr-sm-5 text-white border border-white px-3 py-2 rounded">
            Admin
        </Link>
      </Navbar>
      <div className="p-3 p-sm-5 d-flex flex-column justify-content-around h-100">
        <Alert variant="danger">
          Consignes COVID-19
        </Alert>
        <Picker mosquee={mosquee} data={data} callback={setMosquee} />
        {mosquee !== null && <span className="ml-2 mb-3 d-flex align-items-center"><InfoCircle className="mr-2" />Adresse: {data.find((item) => item.value === mosquee).adress}  <a className="ml-2" target="_blank" rel="noopener noreferrer" href={data.find((item) => item.value === mosquee).link} alt="Maps">Trouver sur Google Maps <BoxArrowInUpRight /></a></span>}
        {mosquee !== null && <List mosquee={mosquee} />}
      </div>
    </div>
  );
}

export default Home;
